<template>
    <header id="header"> 
        <dicta-header :english-supported="false" :showPromotions="'nakdan'">
            <template v-if="showLoginOrSignupButton" slot="endContent">
                <LoginLogout v-on:show-user-settings="showUserSettings" ></LoginLogout>
                <UserSettingsPopup :tab="tab" ref="user-settings" ></UserSettingsPopup>
                <!-- pass emitter as prop to componenent-->
            </template>
        </dicta-header>
        <div class="inner-header bg-primary">
            <div class="container">
                <div class="row">
                    <div class="col-6 text-right">
                        <div class="v-center">
                          <span @click="titleOrLogoClicked" class="logo"><img alt="logo" class="logo-img" src="../assets/logo.png"></span>
                          <div class="two-line-title">
                            <span @click="titleOrLogoClicked" class="title-text text-white">נקדן
                              <span v-if="NakdanType.Pro"> מקצועי<br />
                                <span class="title-text text-light">גירסת בטא</span>
                              </span>
                            </span>
                            <span v-if="NakdanType.Simple" class="title-text text-light"><br />
                              <a @click.prevent="goToProClicked" href="https://nakdanpro.dicta.org.il">עברו לנקדן מתקדם</a>
                            </span>
                          </div>
                        </div>
                    </div>
                    <div class="col-6 left-items">
                        <a id="shortcutsLink" class="show-keyboard-shortcuts ml-3" href="#" @click="showKeyboardShortcutsClicked">קיצורי מקלדת</a>
                        <button id="instructionsButton" @click="howToUseClicked" class="btn btn-primary btn-outline-light ">איך זה עובד</button>
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="showGoHomePrompt"
                id="go-home-modal"
                size="sm"
                centered
                hide-header
                ok-title="עבור"
                cancel-title="ביטול"
                footer-class="go-home-footer"
                @ok="actuallyGoHome">
          <p class="text-center mb-0">במעבר לדף הבית, תאבדו את <br/>הטקסט הקיים</p>
          <span class="text-center"><b-form-checkbox v-model="disableGoHomePromptOption">אל תציג שוב</b-form-checkbox></span>
        </b-modal>
        <b-modal v-model="showGoToProPrompt"
                id="go-to-pro-modal"
                size="sm"
                centered
                hide-header
                ok-title="עבור"
                cancel-title="ביטול"
                footer-class="go-to-pro-footer"
                @ok="actuallyGoToPro">
          <p class="text-center mb-0">במעבר לנקדן אחר, תאבדו את <br/>הטקסט הקיים</p>
        </b-modal>
        <how-to-use-popup :show-how-to-use-popup="showHowToUsePopup" />
    </header>
</template>
<script>
import LoginLogout from './LoginLogout'
import serviceMixins from '@/mixins/serviceMixins'
import UserSettingsPopup from './UserSettingsPopup'
import HowToUsePopup from './HowToUsePopup'
import {NakdanType, SimpleVsProConfig} from '@/simpleVsProConfig.js'

export default {
  components: {
      LoginLogout,
      UserSettingsPopup,
      HowToUsePopup
  },
  name: 'headers',
  props: ['globalModesObj'],
  data () {
    return {
      tab: { // only relevant in 'Pro' Nakdan
        activeTab: 'profile',
        activeSet: 'profile'
      },
      showHowToUsePopup: false, // only relevant in 'Simple' Nakdan
      showGoHomePrompt: false,
      showGoToProPrompt: false, // only relevant in 'Simple' Nakdan
      disableGoHomePromptOption: null // set when mounting
    }
  },
  computed: {
    NakdanType () {
      return NakdanType
    },
    showLoginOrSignupButton () {
      return SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS
    }
  },
  mixins: [serviceMixins], // for gtag()
  methods: {
    goToProClicked () {
      if (this.$route.name === 'nikud-edit' || this.$store.state.originalDocument.text.length) { 
        this.showGoToProPrompt = true
      } else this.actuallyGoToPro()
    },
    actuallyGoToPro () {
      this.gtag("event", "redirect", {
        'event_category': 'common header',
        'event_label': 'go-to-pro clicked'
      })
      this.globalModesObj.allowLeaving = true
      window.location = 'https://nakdanpro.dicta.org.il'
    },
    showUserSettings (tab) { // only relevant in 'Pro' Nakdan
       this.tab.activeTab = tab
       this.tab.activeSet = tab
       this.$refs['user-settings'].$children[0].show() // the $ref is the COMPONENT, $children[0] is the modal
    },
    showKeyboardShortcutsClicked () {
      this.$emit('show-keyboard-shortcuts')
      this.gtag("event", "show popup", {
        'event_category': 'common header',
        'event_label': 'show-shortcuts clicked'
      })
    },
    howToUseClicked () {
      this.gtag("event", "show popup", {
        'event_category': 'common header',
        'event_label': 'how-to-use clicked'
      })
      document.activeElement.blur()
      if (SimpleVsProConfig.HOW_TO_USE_OPENS.DOCUMENTATION_TAB) window.open('/documentation')
      if (SimpleVsProConfig.HOW_TO_USE_OPENS.POPUP) {
        this.showHowToUsePopup = false // because the modal reacts to CHANGE in showHowToUsePopup
        setTimeout(() => {
          this.showHowToUsePopup = true
        }, 100)
      }
    },
    titleOrLogoClicked () {
      if (this.$route.name === 'text-prep') return
      document.activeElement.blur()
      if (this.$store.state.allWorkingNikud.wordsArray.length 
          && !(this.$store.state.postSubmissionOptions.disableGoHomePrompt)) { 
        this.showGoHomePrompt = true
      } else this.actuallyGoHome()
    },
    actuallyGoHome () {
      this.showGoHomePrompt = false
      if (this.disableGoHomePromptOption) this.$store.commit('SET_DISABLE_GO_HOME_PROMPT', true)
      this.$store.commit('EDIT_DOCUMENT_TEXT', '')
      this.$router.push({ name: 'text-prep' })
    }
  },
  mounted () {
    this.disableGoHomePromptOption = this.$store.state.postSubmissionOptions.disableGoHomePrompt
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .inner-header {
    height: 50px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
    display: flex;
    align-items: center;
  }

  .logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    background-color: white;
    margin: 0 0 0 10px;
  }

  .logo, .title-text {
    cursor: pointer;
  }

  .logo-img {
    margin-top: 1px;
    width: 18px;
  }

  .v-center {
    display: flex;
    align-items: center;
  }

  .left-items {
      display: flex;
      align-items: center;
      justify-content: flex-end;
  }

  .show-keyboard-shortcuts {
      color: white;
      text-decoration: underline;
  }

  /* settings below here are used only by the 'Pro' Nakdan */
  .two-line-title {
    line-height: 1.15rem;
  }

  .text-light, .text-light a {
    color: #d6ecff !important;
    font-size: 0.75rem;
  }
  .text-light a {
    text-decoration: underline;
  }
</style>
